import type { SocialPlatform } from './types';
import { SOCIAL_PLATFORM_CONFIG } from './types';

// Mimics Elections logic, but allows mailto links to be discovered and displayed as a social link

// Extracts the hostname from a social platform URL string
export function getSocialPlatformHostname(url: string): string {
	try {
		if (url.startsWith('mailto:')) {
			return 'mailto';
		}
		// Remove leading @ if present
		const cleanUrl = url.startsWith('@') ? url.slice(1) : url;
		// Add protocol if missing
		const urlWithProtocol = cleanUrl.startsWith('http') ? cleanUrl : `https://${cleanUrl}`;
		const { hostname } = new URL(urlWithProtocol);
		// Remove 'www.' prefix for consistent matching
		return hostname.replace(/^www\./, '');
	} catch {
		return '';
	}
}
// Checks if a URL belongs to a specific social platform
export function urlMatchesSocialPlatform(url: string, platform: SocialPlatform): boolean {
	// Different from Elections logic, we allow mailto links to be discovered and displayed as a social link
	if (platform === 'mailto') {
		return url.startsWith('mailto:');
	}

	const hostname = getSocialPlatformHostname(url);
	if (!hostname) return false;

	const { domains } = SOCIAL_PLATFORM_CONFIG[platform];
	return domains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}
